import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 6 }

import { i18n } from '@/i18n';
import RowCheckBox from '@/components/atom/RowCheckBox.vue';
import { TableContentProperty } from '../interface/tableContentHeaders';
import { BaseTableContentViewModel } from '../baseTableContentViewModel';
import { TableContentItem } from '../interface/tableContentItems';
import TableCell from './TableCell.vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { convertIDateToDateFormat, convertUnixTimeToIDate } from '@/corePagesModule/BaseTableContent/utils/dateFormat';
import { computed } from 'vue';
import { TableType } from '@/coreDomainsModule/table';
import { UserAccount } from '@/coreDomainsModule/entities/users';
import { UserAccountService } from '@/coreDomainsModule/services/userAccountService';

// Propsの定義

export default /*@__PURE__*/_defineComponent({
  __name: 'CommonTableCell',
  props: {
    header: {},
    headerIndex: {},
    accumulationTableContentWidth: {},
    stableColumnCount: {},
    item: {},
    isEditing: { type: Boolean },
    isBold: { type: Boolean },
    isChecked: { type: Boolean },
    isCheckedBusinessId: { type: Boolean },
    isExpanded: { type: Boolean },
    tableType: {}
  },
  emits: ["onCheckboxSelected", "setNarrowState", "onClickedExpansion", "onCheckboxSelectedBusinessId"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const t = i18n.t;

const baseTableContentVM = new BaseTableContentViewModel();

const textAlign = computed(() => {
  if (['choiceBusinessId', 'choice'].includes(props.header.key)) {
    return 'center';
  }
  return props.header.propertyPath?.propertyType === 'number' ? 'right' : 'left';
});

const getSupplierForecastResponsibleUserNames = computed(() => {
  if (!props.item?.aggregateBusinessResponsibleUsers || props.item.aggregateBusinessResponsibleUsers.length === 0) {
    return '--';
  }
  return props.item.aggregateBusinessResponsibleUsers.map((user: UserAccount) => UserAccountService.getDisplayName(user)).join(', ');
});
const getCustomerForecastResponsibleUserNames = computed(() => {
  if (!props.item?.baseBusinessResponsibleUsers || props.item.baseBusinessResponsibleUsers.length === 0) {
    return '--';
  }
  return props.item.baseBusinessResponsibleUsers.map((user: UserAccount) => UserAccountService.getDisplayName(user)).join(', ');
});

const getToolTipValue = computed(() => {
  if (props.header.key === 'supplierForecastResponsibleUser') {
    return getSupplierForecastResponsibleUserNames.value;
  }
  if (props.header.key === 'customerForecastResponsibleUser') {
    return getCustomerForecastResponsibleUserNames.value;
  }
  return props.item[props.header.key];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableCell, {
    class: _normalizeClass([{ 'sticky-content': _unref(baseTableContentVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex) }, "table-cell base-table__body--fixed"]),
    style: _normalizeStyle({
      left: _unref(baseTableContentVM).calcStickyDiff(_ctx.stableColumnCount, _ctx.headerIndex, _ctx.accumulationTableContentWidth[_ctx.headerIndex]),
    }),
    "text-align": textAlign.value,
    "table-content-property": _ctx.header,
    "tool-tip-value": getToolTipValue.value,
    "is-highlighted": props.isChecked || props.isCheckedBusinessId
  }, {
    default: _withCtx(() => [
      (_ctx.header.key === 'choice')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.tableType === 'firmOrderTable' || (!_ctx.isEditing && !_ctx.item.isVirtualChild))
              ? (_openBlock(), _createBlock(RowCheckBox, {
                  key: 0,
                  "is-checked": _ctx.isChecked,
                  class: "md-primary all-check-button",
                  onChangeStatus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onCheckboxSelected', _ctx.item?.displayId)))
                }, null, 8, ["is-checked"]))
              : _createCommentVNode("", true)
          ], 64))
        : (_ctx.header.key === 'choiceBusinessId')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (!_ctx.isEditing && !_ctx.item.isVirtualChild)
                ? (_openBlock(), _createBlock(RowCheckBox, {
                    key: 0,
                    "is-checked": _ctx.isCheckedBusinessId,
                    class: "md-primary all-check-button",
                    onChangeStatus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onCheckboxSelectedBusinessId', _ctx.item?.businessId)))
                  }, null, 8, ["is-checked"]))
                : _createCommentVNode("", true)
            ], 64))
          : (_ctx.header.key === 'expansion')
            ? (_openBlock(), _createBlock(SvgLoader, {
                key: 2,
                class: "expansion-button",
                name: _ctx.isExpanded ? 'arrowDownSize24' : 'chevronRight',
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('onClickedExpansion', !_ctx.isExpanded)))
              }, null, 8, ["name"]))
            : (_ctx.header.key === 'businessUpdateAt')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 3,
                  class: _normalizeClass(["table-cell-content", { 'table-cell-content': _ctx.isBold }]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('setNarrowState', _ctx.header, _ctx.item.updateAt)))
                }, _toDisplayString(_unref(convertIDateToDateFormat)(_unref(convertUnixTimeToIDate)(_ctx.item.updatedAt))), 3))
              : (_ctx.header.key === 'supplierForecastResponsibleUser')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 4,
                    class: _normalizeClass(["table-cell-content", { 'table-cell-content': _ctx.isBold }]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('setNarrowState', _ctx.header, _ctx.item[_ctx.header.key])))
                  }, _toDisplayString(getSupplierForecastResponsibleUserNames.value), 3))
                : (_ctx.header.key === 'customerForecastResponsibleUser')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 5,
                      class: _normalizeClass(["table-cell-content", { 'table-cell-content': _ctx.isBold }]),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('setNarrowState', _ctx.header, _ctx.item[_ctx.header.key])))
                    }, _toDisplayString(getCustomerForecastResponsibleUserNames.value), 3))
                  : (_ctx.header.key === 'headerModify')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 7,
                        class: _normalizeClass(["table-cell-content", { 'table-cell-content': _ctx.isBold }]),
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('setNarrowState', _ctx.header, _ctx.item[_ctx.header.key])))
                      }, _toDisplayString(_ctx.item[_ctx.header.key] ?? '--'), 3))
    ], undefined, true),
    _: 1
  }, 8, ["class", "style", "text-align", "table-content-property", "tool-tip-value", "is-highlighted"]))
}
}

})